export function multiSelect(root = document) {
  const qsa = (s, r = document) => Array.from(r.querySelectorAll(s));
  const selects = qsa('.multiple-select', root);
  console.log('[multiSelect] Found selects:', selects.length, selects);
  selects.forEach(enhanceSelect);
}

function enhanceSelect(select) {
  if (!select || select.__msdEnhanced) {
    console.log('[multiSelect] Skipping select (already enhanced or null):', select);
    return;
  }
  select.__msdEnhanced = true;
  console.log('[multiSelect] Enhancing select:', select.id, select);

  // Wrapper
  const wrap = document.createElement('div');
  wrap.className = 'farlo-ui-multi-select';
  select.parentNode.insertBefore(wrap, select);
  wrap.appendChild(select);

  select.classList.add('farlo-ui-multi-select__native');

  const btn = document.createElement('button');
  btn.type = 'button';
  btn.className = 'farlo-ui-multi-select__button';
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-haspopup', 'listbox');
  btn.id = select.id ? `${select.id}__msd` : `msd_${Math.random().toString(36).slice(2)}`;
  wrap.insertBefore(btn, select);

  const panel = document.createElement('div');
  panel.className = 'farlo-ui-multi-select__panel';
  panel.setAttribute('role', 'group');
  panel.setAttribute('aria-labelledby', btn.id);
  panel.hidden = true;
  wrap.appendChild(panel);

  const ctrls = document.createElement('div');
  ctrls.className = 'farlo-ui-multi-select__controls';
  ctrls.innerHTML = `
    <input class="farlo-ui-multi-select__search" type="text" placeholder="Filter…" aria-label="Filter options">
    <div class="farlo-ui-multi-select__actions">
      <button type="button" class="farlo-ui-multi-select__act farlo-ui-multi-select__none">Clear</button>
    </div>
  `;
  panel.appendChild(ctrls);

  // List
  const list = document.createElement('ul');
  list.className = 'farlo-ui-multi-select__list';
  list.setAttribute('role', 'listbox');
  list.setAttribute('aria-multiselectable', 'true');
  panel.appendChild(list);

  // Build items
  Array.from(select.options).forEach((opt, i) => {
    list.appendChild(createItem(select, opt, i));
  });

  // Button label
  function updateButton() {
    const selected = Array.from(select.selectedOptions).map(o => o.textContent.trim());
    if (selected.length === 0) {
      btn.textContent = select.getAttribute('aria-label') || 'Select…';
    } else if (selected.length <= 2) {
      btn.textContent = selected.join(', ');
    } else {
      btn.textContent = `${selected.slice(0, 2).join(', ')} +${selected.length - 2}`;
    }
  }
  updateButton();

  function openPanel() {
    panel.hidden = false;
    btn.setAttribute('aria-expanded', 'true');
    (panel.querySelector('.farlo-ui-multi-select__search') || panel.querySelector('.farlo-ui-multi-select__checkbox'))?.focus();
    document.addEventListener('click', onDocClick, { capture: true });
    document.addEventListener('keydown', onKeyDown);
  }
  function closePanel() {
    panel.hidden = true;
    btn.setAttribute('aria-expanded', 'false');
    document.removeEventListener('click', onDocClick, { capture: true });
    document.removeEventListener('keydown', onKeyDown);
    btn.focus();
  }
  function togglePanel() { panel.hidden ? openPanel() : closePanel(); }

  btn.addEventListener('click', togglePanel);

  function onDocClick(e) {
    if (!wrap.contains(e.target)) closePanel();
  }
  function onKeyDown(e) {
    if (e.key === 'Escape') { e.preventDefault(); closePanel(); return; }
    if (e.key === 'ArrowDown' || e.key === 'ArrowUp') {
      const focusables = [
        panel.querySelector('.farlo-ui-multi-select__search'),
        ...Array.from(panel.querySelectorAll('.farlo-ui-multi-select__checkbox'))
      ].filter(Boolean);
      const i = focusables.indexOf(document.activeElement);
      const dir = e.key === 'ArrowDown' ? 1 : -1;
      const next = Math.max(0, Math.min(focusables.length - 1, i + dir));
      focusables[next]?.focus();
      e.preventDefault();
    }
    if ((e.key === 'Enter' || e.key === ' ') &&
        document.activeElement?.classList.contains('farlo-ui-multi-select__checkbox')) {
      document.activeElement.click();
      e.preventDefault();
    }
  }

  // Search filter
  const searchInput = panel.querySelector('.farlo-ui-multi-select__search');
  searchInput.addEventListener('input', () => {
    const needle = searchInput.value.trim().toLowerCase();
    Array.from(list.children).forEach(li => {
      const text = li.querySelector('.farlo-ui-multi-select__text')?.textContent.toLowerCase() || '';
      li.style.display = text.includes(needle) ? '' : 'none';
    });
  });

  // Actions
  panel.querySelector('.farlo-ui-multi-select__none').addEventListener('click', () => {
    Array.from(select.options).forEach(opt => (opt.selected = false));
    list.querySelectorAll('.farlo-ui-multi-select__checkbox').forEach(cb => (cb.checked = false));
    list.querySelectorAll('.farlo-ui-multi-select__item').forEach(li => li.setAttribute('aria-selected', 'false'));
    updateButton();
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  // Keep in sync if native select changes elsewhere
  select.addEventListener('change', () => {
    Array.from(select.options).forEach((opt, i) => {
      const li = list.children[i];
      const cb = li?.querySelector('.farlo-ui-multi-select__checkbox');
      if (!cb) return;
      cb.checked = opt.selected;
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
    });
    updateButton();
  });
}

function createItem(select, opt, idx) {
  const li = document.createElement('li');
  li.className = 'farlo-ui-multi-select__item';
  li.setAttribute('role', 'option');
  li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');

  const id = (select.id || 'farlo-ui-multi-select') + '_opt_' + idx;

  li.innerHTML = `
    <label class="farlo-ui-multi-select__label" for="${id}">
      <input type="checkbox" class="farlo-ui-multi-select__checkbox" id="${id}" ${opt.selected ? 'checked' : ''} value="${opt.value}">
      <span class="farlo-ui-multi-select__text">${opt.textContent}</span>
    </label>
  `;

  const cb = li.querySelector('.farlo-ui-multi-select__checkbox');
  cb.addEventListener('change', () => {
    opt.selected = cb.checked;
    li.setAttribute('aria-selected', cb.checked ? 'true' : 'false');
    select.dispatchEvent(new Event('change', { bubbles: true }));
  });

  return li;
}
